// Users router
export default [
  {
    path: 'tasks',
    name: 'tasks',
    redirect: 'tasks/index',
    component: () =>
      import(/* webpackChunkName: "tasks" */ '../views/tasks/Tasks.vue'),
    children: [
      {
        path: 'index',
        name: 'tasksIndex',
        meta: {
          tabbable: true,
          tableKeys: ['tasks'],
          filterKeys: ['tasks'],
          formKeys: [],
          routePermissions: ['systemAdministration'],
        },
        component: () =>
          import(
            /* webpackChunkName: "tasksIndex" */ '../views/tasks/TasksIndex.vue'
          ),
      },
    ],
  },
];
